import { Link } from '@app/components/various/Link';
import { CollapsibleTooltipCell } from '@app/components/various/Table/Cells/CollapsibleTooltipCell';
import { compiledPaths } from '@app/paths';
import { Cms } from '@typings';
import { useTranslation } from 'react-i18next';

import { PreviouslyTableCell } from '../PreviouslyTableCell/PreviouslyTableCell';

interface Props {
  slug: string;
  row: Cms.Page;
}

export const SlugCell = ({ slug, row }: Props) => {
  const { t } = useTranslation(['cms']);

  return (
    <PreviouslyTableCell property="slug" page={row}>
      <CollapsibleTooltipCell
        className="max-w-48"
        as={Link}
        title={t('cms:page_preview')}
        to={compiledPaths.CMS_PREVIEW({ pageId: row.id })}
      >
        {slug}
      </CollapsibleTooltipCell>
    </PreviouslyTableCell>
  );
};
